// import { useState } from "react";
// import { Box, Button } from "@mui/material";
// import SellStatus from "./SellStatus";
// import Withdrawal from "./Withdrawal";
// import UpdateKyc from "./UpdateKyc";
// import { useSelector } from "react-redux";

// export default function UpdateKycTab() {
//   const roleResponse = useSelector((state) => state.login.login.role);

//   const [activeTab, setActiveTab] = useState("SellStatus");
//   const style = {
//     flex: 1, // ✅ Equal width for all buttons
//     height: { xs: 40, sm: 60, md: 35 }, // ✅ Equal height
//     maxWidth: { xs: "100%", md: 150 }, // ✅ Better alignment on desktop
//     fontSize: { xs: "10px", sm: "13px", md: "14px" },
//     padding: { xs: "5px 4px", md: "8px 8px" },
//     display: "flex",
//     flexDirection: {
//       xs: "column", // ✅ Mobile: stacked
//       md: "row", // ✅ Desktop: normal text
//     },
//     justifyContent: "center",
//     alignItems: "center",
//     whiteSpace: "normal",
//     // textAlign: "center",
//     lineHeight: 1.2,
//   };
//   return (
//     <>
//       <Box>
//         <Box
//           display="flex"
//           justifyContent="center"
//           gap={{ xs: 0.5, md: 2 }}
//           mb={2}
//         >
//           <Button
//             variant={activeTab === "SellStatus" ? "contained" : "outlined"}
//             onClick={() => setActiveTab("SellStatus")}
//             sx={style}
//           >
//             Sell Status
//           </Button>
//           {roleResponse?.kycUpdate?.update === 1 && (
//             <Button
//               variant={activeTab === "UpdateKyc" ? "contained" : "outlined"}
//               onClick={() => setActiveTab("UpdateKyc")}
//               sx={style}
//             >
//               Update Kyc
//             </Button>
//           )}

//           {roleResponse?.kycUpdate?.update === 1 && (
//             <Button
//               variant={activeTab === "Withdrawal" ? "contained" : "outlined"}
//               onClick={() => setActiveTab("Withdrawal")}
//               sx={style}
//             >
//               Withdrawal
//             </Button>
//           )}
//         </Box>

//         {activeTab === "SellStatus" && <SellStatus />}
//         {activeTab === "Withdrawal" && <Withdrawal />}
//         {activeTab === "UpdateKyc" && <UpdateKyc />}
//       </Box>
//     </>
//   );
// }

//-------------------------tab vala  code--------------------------
// import { useState } from "react";
// import { Box, Button } from "@mui/material";
// import SellStatus from "./SellStatus";
// import Withdrawal from "./Withdrawal";
// import UpdateKyc from "./UpdateKyc";
// import { useSelector } from "react-redux";

// export default function UpdateKycTab() {
//   const roleResponse = useSelector((state) => state.login.login.role);

//   const [activeTab, setActiveTab] = useState("SellStatus");
//   const [kycSubTab, setKycSubTab] = useState("Augmont"); // ✅ default

//   const style = {
//     flex: 1,
//     height: { xs: 40, sm: 60, md: 35 },
//     maxWidth: { xs: "100%", md: 150 },
//     fontSize: { xs: "10px", sm: "13px", md: "14px" },
//     padding: { xs: "5px 4px", md: "8px 8px" },
//     display: "flex",
//     flexDirection: { xs: "column", md: "row" },
//     justifyContent: "center",
//     alignItems: "center",
//     lineHeight: 1.2,
//   };

//   const subTabStyle = {
//  flex: 1,
//     height: { xs: 40, sm: 60, md: 35 },
//     maxWidth: { xs: "100%", md: 150 },
//     fontSize: { xs: "10px", sm: "13px", md: "14px" },
//     padding: { xs: "5px 4px", md: "8px 8px" },
//     display: "flex",
//     flexDirection: { xs: "column", md: "row" },
//     justifyContent: "center",
//     alignItems: "center",
//     lineHeight: 1.2,
// };

//   return (
//     <Box>

//       {/* -------- MAIN TABS -------- */}
//       <Box display="flex" justifyContent="center" gap={2} mb={2}>
//         <Button
//           variant={activeTab === "SellStatus" ? "contained" : "outlined"}
//           onClick={() => setActiveTab("SellStatus")}
//           sx={style}
//         >
//           Sell Status
//         </Button>

//         {roleResponse?.kycUpdate?.update === 1 && (
//           <Button
//             variant={activeTab === "UpdateKyc" ? "contained" : "outlined"}
//             onClick={() => {
//               setActiveTab("UpdateKyc");
//               setKycSubTab("Augmont"); // ✅ default focus
//             }}
//             sx={style}
//           >
//             Update Kyc
//           </Button>
//         )}

//         {roleResponse?.kycUpdate?.update === 1 && (
//           <Button
//             variant={activeTab === "Withdrawal" ? "contained" : "outlined"}
//             onClick={() => setActiveTab("Withdrawal")}
//             sx={style}
//           >
//             Withdrawal
//           </Button>
//         )}
//       </Box>

//       {/* -------- SUB TABS (Only for UpdateKyc) -------- */}
//       {activeTab === "UpdateKyc" && (
//         <Box
//           display="flex"
//           justifyContent={{ xs: "space-between", md: "center" }}
//           gap={{ xs: 1, md: 2 }}
//           mb={2}
//           flexWrap="wrap" // ✅ wrap buttons on smaller screens
//         >

//           <Button
//             variant={kycSubTab === "Augmont" ? "contained" : "outlined"}
//             onClick={() => setKycSubTab("Augmont")}
//             sx={subTabStyle}
//           >
//             Augmont Kyc
//           </Button>

//           <Button
//             variant={kycSubTab === "MMTC" ? "contained" : "outlined"}
//             onClick={() => setKycSubTab("MMTC")}
//             sx={subTabStyle}
//           >
//             MMTC Kyc
//           </Button>
//         </Box>
//       )}

//       {/* -------- CONTENT -------- */}
//       {activeTab === "SellStatus" && <SellStatus />}

//       {activeTab === "Withdrawal" && <Withdrawal />}

//       {activeTab === "UpdateKyc" && kycSubTab === "Augmont" && (
//         <UpdateKyc type="augmont" />
//       )}

//       {activeTab === "UpdateKyc" && kycSubTab === "MMTC" && (
//         <UpdateKyc type="mmtc" />
//       )}

//     </Box>
//   );
// }

//--------------closing tab vala code------------

//---------------------again new code--------------------------

// import { Box, Grid } from "@mui/material";
// import SellStatus from "./SellStatus";
// import Withdrawal from "./Withdrawal";
// import UpdateKyc from "./UpdateKyc";
// import { useSelector } from "react-redux";
// import { useState } from "react";

// export default function UpdateKycTab() {
//   const roleResponse = useSelector((state) => state.login.login.role);
//   const [activeTab, setActiveTab] = useState("SellStatus");

//   return (
//     <Box>

//       {/* -------- MAIN TABS -------- */}
//       <Box display="flex" justifyContent="center" gap={2} mb={2}>
//         <button onClick={() => setActiveTab("SellStatus")}>
//           Sell Status
//         </button>

//         {roleResponse?.kycUpdate?.update === 1 && (
//           <button onClick={() => setActiveTab("UpdateKyc")}>
//             Update Kyc
//           </button>
//         )}

//         {roleResponse?.kycUpdate?.update === 1 && (
//           <button onClick={() => setActiveTab("Withdrawal")}>
//             Withdrawal
//           </button>
//         )}
//       </Box>

//       {/* -------- CONTENT -------- */}
//       {activeTab === "SellStatus" && <SellStatus />}

//       {activeTab === "Withdrawal" && <Withdrawal />}

//       {activeTab === "UpdateKyc" && (
//         <Grid container spacing={3}>

//           {/* LEFT HALF - AUGMONT */}
//           <Grid item xs={12} md={6}>
//             <UpdateKyc type="augmont" />
//           </Grid>

//           {/* RIGHT HALF - MMTC */}
//           <Grid item xs={12} md={6}>
//             <UpdateKyc type="mmtc" />
//           </Grid>

//         </Grid>
//       )}
//     </Box>
//   );
// }

//--------------------without tab vala code ----------------------

import { Box, Button, Grid } from "@mui/material";
import SellStatus from "./SellStatus";
import Withdrawal from "./Withdrawal";
import UpdateKyc from "./UpdateKyc";
import { useSelector } from "react-redux";
import { useState } from "react";

export default function UpdateKycTab() {
  const roleResponse = useSelector((state) => state.login.login.role);
  const [activeTab, setActiveTab] = useState("SellStatus");

  const style = {
    flex: 1,
    height: { xs: 40, sm: 60, md: 35 },
    maxWidth: { xs: "100%", md: 150 },
    fontSize: { xs: "10px", sm: "13px", md: "14px" },
    padding: { xs: "5px 4px", md: "8px 8px" },
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "center",
    alignItems: "center",
    lineHeight: 1.2,
  };

  return (
    <Box>
      {/* -------- MAIN TABS -------- */}
      <Box display="flex" justifyContent="center" gap={2} mb={2}>
        <Button
          variant={activeTab === "SellStatus" ? "contained" : "outlined"}
          onClick={() => setActiveTab("SellStatus")}
          sx={style}
        >
          Sell Status
        </Button>

        {roleResponse?.kycUpdate?.update === 1 && (
          <Button
            variant={activeTab === "UpdateKyc" ? "contained" : "outlined"}
            onClick={() => setActiveTab("UpdateKyc")}
            sx={style}
          >
            Update Kyc
          </Button>
        )}

        {roleResponse?.kycUpdate?.update === 1 && (
          <Button
            variant={activeTab === "Withdrawal" ? "contained" : "outlined"}
            onClick={() => setActiveTab("Withdrawal")}
            sx={style}
          >
            Withdrawal
          </Button>
        )}
      </Box>

      {/* -------- CONTENT -------- */}
      {activeTab === "SellStatus" && <SellStatus />}

      {activeTab === "Withdrawal" && <Withdrawal />}

      {activeTab === "UpdateKyc" && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <UpdateKyc type="augmont" />
          </Grid>

          <Grid item xs={12} md={6}>
            <UpdateKyc type="mmtc" />
          </Grid>
        </Grid>
      )}
    </Box>
  );
}

//----------------closing without tab vala code-------------------------------------
